import * as React from 'react';
import { useSelector } from 'react-redux';
import ContentLayout from 'components/common/layouts/ContentLayout';
import SearchFilter from 'components/member/connect/SearchFilter';
import MemberListTable from 'components/member/connect/MemberListTable';
import {
  selectConnectMemberList,
  selectConnectMemberListLoading,
} from 'features/member/reducer/connectMemberListSlice';
import useConnectMemberSearchFilter from 'hooks/useConnectMemberSearchFilter';

const MemberConnectContainer = () => {
  const { items: memberList, totalPages, totalItems } = useSelector(selectConnectMemberList);
  const memberListLoading = useSelector(selectConnectMemberListLoading);

  const {
    currentPageIndex,
    keyword,
    connectAbusingUserStatus,
    connectUserType,
    connectCommunityUserType,
    connectAchievementBadge,
    onChangeConnectAbusingUser,
    onChangeConnectUserType,
    onChangeConnectCommunityUserType,
    onChangeConnectAchievementBadge,
    onChangeKeyword,
    onKeyDownKeyword,
    getSearchResult,
    resetFilter,
    onChangePage,
  } = useConnectMemberSearchFilter();

  return (
    <ContentLayout pageTitle={'Member'}>
      <SearchFilter
        keyword={keyword}
        onChangeKeyword={onChangeKeyword}
        onKeyDownKeyword={onKeyDownKeyword}
        connectAbusingUserStatus={connectAbusingUserStatus}
        connectAchievementBadge={connectAchievementBadge}
        connectUserType={connectUserType}
        connectCommunityUserType={connectCommunityUserType}
        onChangeConnectAbusingUser={onChangeConnectAbusingUser}
        onChangeConnectUserType={onChangeConnectUserType}
        onChangeConnectCommunityUserType={onChangeConnectCommunityUserType}
        onChangeConnectAchievementBadge={onChangeConnectAchievementBadge}
        onClickSearch={getSearchResult}
        onClickReset={resetFilter}
      />
      <MemberListTable
        memberListLoading={memberListLoading}
        totalPages={totalPages}
        onChangePage={onChangePage}
        currentPageIndex={currentPageIndex}
        memberList={memberList}
        totalItems={totalItems}
      />
    </ContentLayout>
  );
};

export default MemberConnectContainer;
